(function () {
  'use strict';

  if ((document.documentElement.lang || '').toLowerCase().indexOf('en') !== 0) return;

  var exact = {
    'Konfigurator': 'Configurator',
    'Opis': 'Description',
    'Dane': 'Specifications',
    'Dostawa': 'Delivery',
    'Cechy': 'Features',
    'Akcesoria': 'Accessories',
    'Opinie': 'Reviews',
    'Podgląd': 'Preview',
    'Polski produkt': 'Made in Poland',
    'WYBRANY POJAZD': 'SELECTED VEHICLE',
    'Wybrany pojazd': 'Selected vehicle',
    'Zmień auto': 'Change vehicle',
    'Produkcja w Polsce': 'Made in Poland',
    'Pod model auta': 'Custom fit',
    'Woda i brud': 'Traps water and dirt',
    'Wybierz rok': 'Select the year',
    'Wybierz rok:': 'Select the year:',
    'Rok:': 'Year:',
    'Wybierz opcję': 'Select an option',
    'Wybierz zestaw': 'Choose your set',
    'Wybierz rodzaj i zestaw mat:': 'Choose the mat type and set:',
    'Wybierz wykończenie i komplet dopasowany do Twojego auta.': 'Choose the finish and set tailored to your car.',
    'Rodzaj dywaników': 'Mat type',
    'Mats type': 'Mat type',
    '3D BEZ RANTÓW': '3D WITHOUT EDGES',
    '3D Z RANTAMI': '3D WITH EDGES',
    'Wybierz kolory': 'Choose colours',
    'Wybierz kształt i kolory:': 'Choose the cell pattern and colours:',
    'Wybierz kształt komórek oraz kolory materiału i obszycia.': 'Choose the cell pattern, mat colour and trim colour.',
    'Kształt komórek': 'Cell pattern',
    'Kolor materialu': 'Mat colour',
    'Kolor materiału': 'Mat colour',
    'Kolor obszycia': 'Trim colour',
    'Kolory (materiał / obszycie)': 'Colours (mat / trim)',
    'Rodzaj': 'Type',
    'Zestaw': 'Set',
    'Materiał': 'Mat colour',
    'Obszycie': 'Trim colour',
    'Romby': 'Diamond',
    'Plastry miodu': 'Honeycomb',
    'Krople': 'Droplets',
    'Plastry Miodu': 'Honeycomb',
    'Popularne pary kolorów': 'Popular colour combinations',
    'Czarny + Czarny': 'Black + black',
    'Czarny + Czerwony': 'Black + red',
    'Czarny + Niebieski': 'Black + blue',
    'Czarny + Beżowy': 'Black + beige',
    'Dostosuj kolory materiału i obszycia': 'Customize mat and trim colours',
    'Czarny': 'Black',
    'Brązowy': 'Brown',
    'Ciemnoszary': 'Dark grey',
    'Jasnoszary': 'Light grey',
    'Granatowy': 'Navy blue',
    'Niebieski': 'Blue',
    'Zielony': 'Green',
    'Czerwony': 'Red',
    'Bordowy': 'Maroon',
    'Jasnobeżowy': 'Light beige',
    'Beżowy': 'Beige',
    'Fioletowy': 'Purple',
    'Jasnozielony': 'Light green',
    'Żółty': 'Yellow',
    'Pomarańczowy': 'Orange',
    'Kość słoniowa': 'Ivory',
    'Różowy': 'Pink',
    'Biały': 'White',
    'Malinowy': 'Raspberry',
    'Miedziany': 'Copper',
    'Cena regularna:': 'Regular price:',
    'Dodatkowe opcje': 'Additional options',
    'Podpiętki': 'Heel pads',
    'Co to jest': 'What is it?',
    'Podpiętka Gumowa': 'Rubber heel pad',
    'Podpiętka metalowa': 'Metal heel pad',
    'Podpiętka z materiału EVA': 'EVA heel pad',
    'Podpiętka plastikowa': 'Plastic heel pad',
    'POLECANE': 'RECOMMENDED',
    'NAJCZĘŚCIEJ WYBIERANY': 'MOST POPULAR',
    'Najczęściej wybierany': 'Most popular',
    'Kolor i komórki jak w dywaniku': 'Colour and cell pattern match the mat',
    'Dodatkowa nakładka tam, gdzie': 'An extra protective pad where',
    'dywanik ściera się najszybciej': 'the mat wears out fastest',
    '— pod piętą kierowcy.': "— under the driver's heel.",
    'Zł': 'zł',
    'OPCJONALNE': 'OPTIONAL',
    'Opcjonalne': 'Optional',
    'Opcjonalnie': 'Optional',
    'Wszystko poniżej jest': 'Everything below is',
    'opcjonalne': 'optional',
    '. Możesz nic nie dodawać i od razu przejść do koszyka.': '. You can skip these extras and continue straight to the cart.',
    'Wszystko poniżej jest opcjonalne. Możesz nic nie dodawać i od razu przejść do koszyka.': 'Everything below is optional. You can skip these extras and continue straight to the cart.',
    'Ekskluzywne Opakowanie Premium (Idealne na prezent)': 'Exclusive premium packaging (perfect for a gift)',
    'Fabryczna Ochrona Anti-Dirt': 'Factory anti-dirt protection',
    'Wzmocnione Szwy Premium': 'Reinforced premium stitching',
    'Organizer do bagażnika Klasyczny M 33x33 cm': 'Classic trunk organizer M 33 × 33 cm',
    'Uwagi do zamówienia': 'Order notes',
    'Np. dodatkowe informacje...': 'For example, additional information…',
    'Dalej': 'Continue',
    'Wstecz': 'Back',
    'Gotowe': 'Done',
    'GOTOWE': 'DONE',
    'Zmień': 'Change',
    'Dodaj': 'Add',
    'Dodaj do koszyka': 'Add to cart',
    'Pokaż podgląd': 'Show preview',
    'Zwiń podgląd': 'Collapse preview',
    'Ukryj': 'Hide',
    'Ukryj podgląd': 'Hide preview',
    'Zamknij': 'Close',
    'Pokaż więcej': 'Show more',
    'Pokaż mniej': 'Show less',
    'Produkcja': 'Production',
    'do 10 dni': 'up to 10 days',
    'do 4 dni': 'up to 4 days',
    'Dywanik kierowcy': "Driver's mat",
    'Dywanik Kierowcy': "Driver's mat",
    'Dywaniki przód': 'Front mats',
    'Dywaniki tył': 'Rear mats',
    'Przód': 'Front',
    'Tył': 'Rear',
    'Przód + tył': 'Front + rear',
    'Przód + Tył': 'Front + rear',
    'Mata do bagażnika': 'Trunk mat',
    'Mata Do Bagażnika': 'Trunk mat',
    'Przód + tył + 3 rząd': 'Front + rear + 3rd row',
    'Przód + Tył + 3 Rząd': 'Front + rear + 3rd row',
    'Przód + tył + 3 rząd + Mały bagażnik': 'Front + rear + 3rd row + small trunk',
    'Przód + Tył + 3 Rząd + Mały Bagażnik': 'Front + rear + 3rd row + small trunk',
    'Przód + tył + 3 rząd + Duży bagażnik': 'Front + rear + 3rd row + large trunk',
    'Przód + Tył + 3 Rząd + Duży Bagażnik': 'Front + rear + 3rd row + large trunk',
    '3 rzędy + 2 Bagażniki (Duży | Mały)': '3 rows + 2 trunks (large | small)',
    '3 Rzędy + 2 Bagażniki (Duży | Mały)': '3 rows + 2 trunks (large | small)',
    'Przód + tył + Duży bagażnik': 'Front + rear + large trunk',
    'Przód + Tył + Duży Bagażnik': 'Front + rear + large trunk',
    /* 06.10.2026: pozostałe komplety z produktów-wzorów zamówienia indywidualnego (lista kompletów na /en) */
    'Przód + tył + bagażnik': 'Front + rear + trunk',
    'Przód + bagażnik': 'Front + trunk',
    'Przód + Bagażnik': 'Front + trunk',
    'Bagażnik': 'Trunk',
    '1 rząd': '1 row',
    '2 rzędy': '2 rows',
    '3 rzędy': '3 rows',
    '3 rzędy+ bagażnik duży (całe auto)': '3 rows + large trunk (whole car)',
    'Duża mata do bagażnika': 'Large trunk mat',
    '1 rząd + Bagażnik': '1 row + trunk',
    '2 rzędy + Bagażnik': '2 rows + trunk',
    'Mata do Bagażnika': 'Trunk mat',
    'Przód Bez Tunelu': 'Front without tunnel',
    'Przód bez tunelu': 'Front without tunnel',
    'Przód z tunelem': 'Front with tunnel',
    'Bagażnik MAŁY': 'Small trunk',
    'Bagażnik DUŻY': 'Large trunk',
    '3 rzędy + bagażnik MAŁY': '3 rows + small trunk',
    '3 rzędy + bagażnik DUŻY': '3 rows + large trunk',
    '3 rzędy + 2 bagażniki mały i duży(całe auto)': '3 rows + 2 trunks (whole car)',
    'Listwa tylna': 'Rear strip',
    '1 szt': '1 pc',
    '2 szt': '2 pcs',
    'Powrót': 'Back'
  };

  var colours = {
    CZARNY: 'BLACK', BRAZOWY: 'BROWN', 'BRĄZOWY': 'BROWN', CIEMNOSZARY: 'DARK GREY',
    JASNOSZARY: 'LIGHT GREY', GRANATOWY: 'NAVY BLUE', NIEBIESKI: 'BLUE', ZIELONY: 'GREEN',
    CZERWONY: 'RED', BORDOWY: 'MAROON', 'JASNOBEŻOWY': 'LIGHT BEIGE', 'BEŻOWY': 'BEIGE',
    FIOLETOWY: 'PURPLE', JASNOZIELONY: 'LIGHT GREEN', 'ŻÓŁTY': 'YELLOW',
    POMARANCZOWY: 'ORANGE', 'POMARAŃCZOWY': 'ORANGE', 'KOŚĆ SŁONIOWA': 'IVORY',
    'RÓŻOWY': 'PINK', 'BIAŁY': 'WHITE', MALINOWY: 'RASPBERRY', MIEDZIANY: 'COPPER'
  };

  function preserveSpace(original, replacement) {
    var leading = original.match(/^\s*/)[0];
    var trailing = original.match(/\s*$/)[0];
    return leading + replacement + trailing;
  }

  function translated(value) {
    var clean = value.trim();
    if (!clean) return null;
    if (exact[clean]) return exact[clean];
    if (colours[clean.toUpperCase()]) return colours[clean.toUpperCase()];
    if (/^KROK\s+\d+\s+Z\s+\d+$/i.test(clean)) {
      return clean.replace(/^KROK\s+(\d+)\s+Z\s+(\d+)$/i, 'STEP $1 OF $2');
    }
    if (/^Obraz\s+(\d+)\s+jest teraz dostępny w widoku galerii$/i.test(clean)) {
      return clean.replace(/^Obraz\s+(\d+)\s+jest teraz dostępny w widoku galerii$/i, 'Image $1 is now available in the gallery viewer');
    }
    if (/^\d+\.\s*Wybierz rok:?$/i.test(clean)) {
      return clean.replace(/^\d+\.\s*Wybierz rok:?$/i, 'Select the year:');
    }
    if (/^Dodaj do koszyka\s*-\s*/i.test(clean)) {
      return clean.replace(/^Dodaj do koszyka/i, 'Add to cart');
    }
    if (/^Pokaż więcej\b/i.test(clean)) return clean.replace(/^Pokaż więcej/i, 'Show more');
    if (/^Pokaż mniej\b/i.test(clean)) return clean.replace(/^Pokaż mniej/i, 'Show less');
    if (/^Darmowa dostawa od\s+/i.test(clean)) return clean.replace(/^Darmowa dostawa od/i, 'Free delivery from');
    if (/^do\s+10\s+dni$/i.test(clean)) return 'up to 10 days';
    if (/^do\s+4\s+dni$/i.test(clean)) return 'up to 4 days';
    if (/^Krople\s*\(([^)]+)\)$/i.test(clean)) return 'Droplets (+' + clean.match(/\+?\s*([\d,.]+)\s*zł/i)?.[1] + ' zł)';
    if (/^Najniższa cena w okresie 30 dni przed obniżką:/i.test(clean)) {
      return clean
        .replace(/^Najniższa cena w okresie 30 dni przed obniżką:/i, 'Lowest price in the 30 days before the discount:')
        .replace(/Cena regularna:/i, 'Regular price:');
    }
    if (/^Brakuje jeszcze\s+/i.test(clean)) {
      return clean.replace(/^Brakuje jeszcze\s+(.+?)\s+do darmowej wysyłki$/i, '$1 left to qualify for free delivery');
    }
    if (clean.indexOf('Podgląd Wyświetlany dywanik służy wyłącznie do podglądu konfiguracji') === 0) {
      return 'Preview: the displayed mat is a configuration visualisation, not a photo of the finished product.';
    }
    if (clean.indexOf('Rok produkcji auta — dopasujemy wykrój do Twojej generacji.') === 0) {
      return 'Select the vehicle year so we can match the correct generation and floor shape.';
    }
    if (/^Pasuje do\s+.+\s+— dopasowany wykrój dla Twojego auta\.$/i.test(clean)) {
      return clean.replace(/^Pasuje do\s+/i, 'Fits ').replace(/— dopasowany wykrój dla Twojego auta\.$/i, '— tailored pattern for your car.');
    }
    if (clean.indexOf('*Podgląd poglądowy') === 0 || clean.indexOf('*Dywanik POGLĄDOWY') === 0) {
      return 'Preview only — the exact colour is selected below.';
    }
    return null;
  }

  // Shared display-only translator for configurator helpers. Raw Shopify option
  // values stay Polish so variant selection and cart properties remain stable.
  window.EVM_EN_CONFIG = {
    translate: function (value) {
      var source = String(value == null ? '' : value);
      return translated(source) || source;
    }
  };

  function translateTextNode(node) {
    var next = translated(node.nodeValue || '');
    if (next !== null) node.nodeValue = preserveSpace(node.nodeValue || '', next);
  }

  function cleanCollectionLabel(element) {
    var value = (element.textContent || '').trim();
    var cleaned = value
      .replace(/^Custom-fit EVA car mats for\s+/i, '')
      .replace(/^EVA car mats for\s+/i, '')
      .replace(/^Car mats for\s+/i, '')
      .replace(/^Car Accessories\s+/i, '');
    if (cleaned && cleaned !== value) element.textContent = cleaned;
  }

  function cleanCollectionLabelForNode(node) {
    var element = node && node.nodeType === 1 ? node : node && node.parentElement;
    if (element && element.matches('.collection-color_block__material, .sidebar-color_block__material')) {
      cleanCollectionLabel(element);
    }
  }

  function translateProcessValue(element) {
    var clean = (element.textContent || '').trim();
    if (!/^do\s+(10|4)\s+dni$/i.test(clean)) return;
    var directTextNodes = Array.prototype.filter.call(element.childNodes, function (node) {
      return node.nodeType === 3;
    });
    if (directTextNodes.length >= 2) {
      directTextNodes[0].nodeValue = 'up to ';
      directTextNodes[directTextNodes.length - 1].nodeValue = ' days';
    }
  }

  function translateMatTypeDescription(label) {
    var input = label.querySelector('input[type="radio"]');
    if (!input && label.htmlFor) input = document.getElementById(label.htmlFor);
    if (!input) return;
    var source = (input.value || '').toLowerCase();
    var next = source.indexOf('bez rant') !== -1 || source.indexOf('without raised') !== -1
      ? 'Lightweight everyday protection'
      : 'Better protection from water and mud';
    if (label.getAttribute('data-evm-desc') !== next) label.setAttribute('data-evm-desc', next);
  }

  function translateYearHint(element) {
    if (!element || !element.matches('.evm-year-hint span')) return;
    var vehicle = element.querySelector('.evm-year-hint__vehicle');
    if (!vehicle) return;
    var before = vehicle.previousSibling;
    var after = vehicle.nextSibling;
    if (before && before.nodeType === 3 && before.nodeValue !== 'Fits ') before.nodeValue = 'Fits ';
    if (after && after.nodeType === 3 && after.nodeValue !== ' — tailored pattern for your car.') {
      after.nodeValue = ' — tailored pattern for your car.';
    }
  }

  function translateYearHintForNode(node) {
    var element = node && node.nodeType === 1 ? node : node && node.parentElement;
    var hint = element && element.closest('.evm-year-hint span');
    if (hint) translateYearHint(hint);
  }

  function translateRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches('.evm-proc__v')) translateProcessValue(root);
    root.querySelectorAll('.evm-proc__v').forEach(translateProcessValue);
    if (root.matches('[data-evm-desc]')) translateMatTypeDescription(root);
    root.querySelectorAll('[data-evm-desc]').forEach(translateMatTypeDescription);
    if (root.matches('.evm-year-hint span')) translateYearHint(root);
    root.querySelectorAll('.evm-year-hint span').forEach(translateYearHint);
    if (root.matches('.collection-color_block__material, .sidebar-color_block__material')) cleanCollectionLabel(root);
    root.querySelectorAll('.collection-color_block__material, .sidebar-color_block__material').forEach(cleanCollectionLabel);

    root.querySelectorAll('input[data-title]').forEach(function (input) {
      var key = (input.getAttribute('data-title') || '').trim().toUpperCase();
      if (colours[key]) input.setAttribute('data-title', colours[key]);
    });

    root.querySelectorAll('[aria-label], [title], [placeholder]').forEach(function (element) {
      ['aria-label', 'title', 'placeholder'].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var current = element.getAttribute(attribute) || '';
        var next = translated(current);
        if (next !== null) element.setAttribute(attribute, next);
      });
    });

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
  }

  function start() {
    if (!document.getElementById('evm-en-config-style')) {
      var style = document.createElement('style');
      style.id = 'evm-en-config-style';
      style.textContent = [
        'html[lang^="en"] .label_oferta::after,html[lang^="en"] .label_oferta.evm-offer-badge::after{content:"RECOMMENDED"!important;}',
        'html[lang^="en"] .product__config_image--main.evm-preview [data-name="mats_type"]::before,html.evm-cro[lang^="en"] .evm-preview [data-name="mats_type"]::before{content:"TYPE"!important;}',
        'html[lang^="en"] .product__config_image--main.evm-preview [data-name="mats_set"]::before,html.evm-cro[lang^="en"] .evm-preview [data-name="mats_set"]::before{content:"SET"!important;}',
        'html[lang^="en"] .product__config_image--main.evm-preview [data-type="matPattern"]::before,html.evm-cro[lang^="en"] .evm-preview [data-type="matPattern"]::before{content:"PATTERN"!important;}',
        'html[lang^="en"] .product__config_image--main.evm-preview [data-type="matColor"]::before,html.evm-cro[lang^="en"] .evm-preview [data-type="matColor"]::before{content:"MAT COLOUR"!important;}',
        'html[lang^="en"] .product__config_image--main.evm-preview [data-type="trimColor"]::before,html.evm-cro[lang^="en"] .evm-preview [data-type="trimColor"]::before{content:"TRIM COLOUR"!important;}'
      ].join('');
      document.head.appendChild(style);
    }
    translateRoot(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 3) {
            translateTextNode(node);
            cleanCollectionLabelForNode(node);
            translateYearHintForNode(node);
          }
          if (node.nodeType === 1) translateRoot(node);
        });
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target);
          cleanCollectionLabelForNode(mutation.target);
          translateYearHintForNode(mutation.target);
        }
        if (mutation.type === 'attributes') translateRoot(mutation.target);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-evm-desc'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
